import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import { TeamInvite } from '../interfaces';
import { postData } from '../backend';
import { useModal } from '../contexts';
import { useState } from 'react';

interface Props {
  invite: TeamInvite;
}

function AcceptInviteModal(props: Props) {
  const { t } = useTranslation();

  const { closeModal } = useModal();

  const [isAccepting, setIsAccepting] = useState(false);

  function handleAcceptInvite() {
    setIsAccepting(true);
    postData("/auth/team/accept-invite/", { team: props.invite.team.id })
      .then(() => {
        window.location.reload();
      }
      )
      .catch((error) => {
        setIsAccepting(false);
        console.error("Failed to accept invite:", error);
      }
      );
  }

  return (
    <Modal
      title={
        <h3 className="font-gilroy font-semibold text-xl">
          {t("You have been invited to join a team!")}
        </h3>
      }
      className='flex flex-col items-center justify-center gap-4 text-center'
      secondaryButtonProps={{
        text: t("Cancel"),
        onClick: () => closeModal()
      }}
      primaryButtonProps={{
        text: isAccepting ? t("Accepting...") : t("Accept"),
        disabled: isAccepting,
        onClick: handleAcceptInvite
      }}
    >
      <div className={`overflow-auto w-full text-left`}>
        {t("Press accept to join the following team:")} <b>{props.invite.team.name}</b>
      </div>
    </Modal>
  );
}

export default AcceptInviteModal;
